export const slugify = (value) => value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
export const deslugify = (value) => value.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
//# sourceMappingURL=slugify.js.map